import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/AuthProvider';
import { ChangeUserPassword } from './Users';

const ForceChangePassword = () => {
  const { user, setUser, setPasswordExpired } = useAuth();
  const navigate = useNavigate();

  const [modalState] = useState({
    open: true,
    userId: user?.id,
  });

  useEffect(() => {
    if (!user || !user.id) {
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);

  if (!user || !user.id) {
    return null;
  }

  const handleSuccess = (updatedUser) => {
    if (updatedUser) {
      setUser(updatedUser);
    }
    setPasswordExpired(false);
    navigate('/devices');
  };

  return (
    <ChangeUserPassword
      state={modalState}
      setState={() => {}}
      canChangePassword={true}
      forceMode={true}
      onSuccess={handleSuccess}
    />
  );
};

export default ForceChangePassword;
